// extracted by mini-css-extract-plugin
export default {"home":"Home_home__5PMJB","workout":"Home_workout__vthc-","workoutgrid":"Home_workoutgrid__zjkRB","spotlight":"Home_spotlight__lL1L2","spotlightgrid":"Home_spotlightgrid__qPQj+"};